import React from 'react';

/**
 * Serves the KCOM state coverage page at /compliance during local development.
 * In production, nginx serves public/compliance/index.html directly (this component is not used).
 */
const ComplianceCoverage = () => (
  <iframe
    src="/compliance/index.html"
    title="KCOM State Coverage"
    className="w-full border-0"
    style={{ height: '100vh' }}
  />
);

export default ComplianceCoverage;
